import { AxiosResponse } from "axios";

import { axiosInstance } from "./common";

export enum FormType {
  // Vehicle Verifications (Physical/Technical & Legal)
  VEHICLE_VALUATION = "VEHICLE_VALUATION",
  VEHICLE_CONDITION = "VEHICLE_CONDITION",
  VEHICLE_EXISTENCE = "VEHICLE_EXISTENCE",
  VEHICLE_REGISTRATION = "VEHICLE_REGISTRATION",
  VEHICLE_CUSTODY = "VEHICLE_CUSTODY",
  VEHICLE_DEALER = "VEHICLE_DEALER",
  VEHICLE_IDENTITY_TAMPER = "VEHICLE_IDENTITY_TAMPER",
  VEHICLE_HYPOTHECATION = "VEHICLE_HYPOTHECATION",
  VEHICLE_DEALER_TAX_INVOICE = "VEHICLE_DEALER_TAX_INVOICE",
  VEHICLE_CERSAI_SEARCH_REPORT = "VEHICLE_CERSAI_SEARCH_REPORT",

  // Plant & Machinery Verifications (Physical/Technical & Legal)
  PLANT_MACHINERY_VALUATION = "PLANT_MACHINERY_VALUATION",
  PLANT_MACHINERY_CONDITION = "PLANT_MACHINERY_CONDITION",
  PLANT_MACHINERY_EXISTENCE = "PLANT_MACHINERY_EXISTENCE",
  PLANT_MACHINERY_CUSTODY = "PLANT_MACHINERY_CUSTODY",
  PLANT_MACHINERY_SUPPLIER = "PLANT_MACHINERY_SUPPLIER",
  PLANT_MACHINERY_INSTALLATION = "PLANT_MACHINERY_INSTALLATION",
  PLANT_MACHINERY_SPECIFICATION = "PLANT_MACHINERY_SPECIFICATION",
  PLANT_MACHINERY_IDENTITY_TAMPER = "PLANT_MACHINERY_IDENTITY_TAMPER",
  PLANT_MACHINERY_DEALER_TAX_INVOICE = "PLANT_MACHINERY_DEALER_TAX_INVOICE",
  PLANT_MACHINERY_CERSAI_SEARCH_REPORT = "PLANT_MACHINERY_CERSAI_SEARCH_REPORT",

  // Commercial Equipment Verifications (Physical/Technical & Legal)
  COMMERCIAL_EQUIPMENT_VALUATION = "COMMERCIAL_EQUIPMENT_VALUATION",
  COMMERCIAL_EQUIPMENT_CONDITION = "COMMERCIAL_EQUIPMENT_CONDITION",
  COMMERCIAL_EQUIPMENT_EXISTENCE = "COMMERCIAL_EQUIPMENT_EXISTENCE",
  COMMERCIAL_EQUIPMENT_CUSTODY = "COMMERCIAL_EQUIPMENT_CUSTODY",
  COMMERCIAL_EQUIPMENT_SUPPLIER = "COMMERCIAL_EQUIPMENT_SUPPLIER",
  COMMERCIAL_EQUIPMENT_INSTALLATION = "COMMERCIAL_EQUIPMENT_INSTALLATION",
  COMMERCIAL_EQUIPMENT_SPECIFICATION = "COMMERCIAL_EQUIPMENT_SPECIFICATION",
  COMMERCIAL_EQUIPMENT_IDENTITY_TAMPER = "COMMERCIAL_EQUIPMENT_IDENTITY_TAMPER",
  COMMERCIAL_EQUIPMENT_DEALER_TAX_INVOICE = "COMMERCIAL_EQUIPMENT_DEALER_TAX_INVOICE",
  COMMERCIAL_EQUIPMENT_CERSAI_SEARCH_REPORT = "COMMERCIAL_EQUIPMENT_CERSAI_SEARCH_REPORT",

  // Precious Metal Verifications (Physical/Technical & Legal)
  PRECIOUS_METAL_VALUATION = "PRECIOUS_METAL_VALUATION",
  PRECIOUS_METAL_AUTHENTICITY = "PRECIOUS_METAL_AUTHENTICITY",
  PRECIOUS_METAL_EXISTENCE = "PRECIOUS_METAL_EXISTENCE",
  PRECIOUS_METAL_CUSTODY = "PRECIOUS_METAL_CUSTODY",
  PRECIOUS_METAL_PLEDGE_AGREEMENT = "PRECIOUS_METAL_PLEDGE_AGREEMENT",
  PRECIOUS_METAL_OWNERSHIP_DECLARATION = "PRECIOUS_METAL_OWNERSHIP_DECLARATION",

  // Real Estate Physical/Technical Verifications
  RESIDENTIAL_REAL_ESTATE_VALUATION = "RESIDENTIAL_REAL_ESTATE_VALUATION",
  RESIDENTIAL_REAL_ESTATE_DIMENSIONS = "RESIDENTIAL_REAL_ESTATE_DIMENSIONS",
  RESIDENTIAL_REAL_ESTATE_EXISTENCE = "RESIDENTIAL_REAL_ESTATE_EXISTENCE",
  RESIDENTIAL_REAL_ESTATE_CUSTODY = "RESIDENTIAL_REAL_ESTATE_CUSTODY",

  COMMERCIAL_REAL_ESTATE_VALUATION = "COMMERCIAL_REAL_ESTATE_VALUATION",
  COMMERCIAL_REAL_ESTATE_DIMENSIONS = "COMMERCIAL_REAL_ESTATE_DIMENSIONS",
  COMMERCIAL_REAL_ESTATE_EXISTENCE = "COMMERCIAL_REAL_ESTATE_EXISTENCE",
  COMMERCIAL_REAL_ESTATE_CUSTODY = "COMMERCIAL_REAL_ESTATE_CUSTODY",

  INDUSTRIAL_REAL_ESTATE_VALUATION = "INDUSTRIAL_REAL_ESTATE_VALUATION",
  INDUSTRIAL_REAL_ESTATE_DIMENSIONS = "INDUSTRIAL_REAL_ESTATE_DIMENSIONS",
  INDUSTRIAL_REAL_ESTATE_EXISTENCE = "INDUSTRIAL_REAL_ESTATE_EXISTENCE",
  INDUSTRIAL_REAL_ESTATE_CUSTODY = "INDUSTRIAL_REAL_ESTATE_CUSTODY",

  // Land Parcel Physical/Technical Verifications
  AGRICULTURAL_LAND_PARCEL_VALUATION = "AGRICULTURAL_LAND_PARCEL_VALUATION",
  AGRICULTURAL_LAND_PARCEL_DIMENSIONS = "AGRICULTURAL_LAND_PARCEL_DIMENSIONS",
  AGRICULTURAL_LAND_PARCEL_EXISTENCE = "AGRICULTURAL_LAND_PARCEL_EXISTENCE",
  AGRICULTURAL_LAND_PARCEL_CUSTODY = "AGRICULTURAL_LAND_PARCEL_CUSTODY",

  NON_AGRICULTURAL_LAND_PARCEL_VALUATION = "NON_AGRICULTURAL_LAND_PARCEL_VALUATION",
  NON_AGRICULTURAL_LAND_PARCEL_DIMENSIONS = "NON_AGRICULTURAL_LAND_PARCEL_DIMENSIONS",
  NON_AGRICULTURAL_LAND_PARCEL_EXISTENCE = "NON_AGRICULTURAL_LAND_PARCEL_EXISTENCE",
  NON_AGRICULTURAL_LAND_PARCEL_CUSTODY = "NON_AGRICULTURAL_LAND_PARCEL_CUSTODY",

  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_VALUATION = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_VALUATION",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_DIMENSIONS = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_DIMENSIONS",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_EXISTENCE = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_EXISTENCE",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CUSTODY = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CUSTODY",

  RESIDENTIAL_PLOT_LAND_PARCEL_VALUATION = "RESIDENTIAL_PLOT_LAND_PARCEL_VALUATION",
  RESIDENTIAL_PLOT_LAND_PARCEL_DIMENSIONS = "RESIDENTIAL_PLOT_LAND_PARCEL_DIMENSIONS",
  RESIDENTIAL_PLOT_LAND_PARCEL_EXISTENCE = "RESIDENTIAL_PLOT_LAND_PARCEL_EXISTENCE",
  RESIDENTIAL_PLOT_LAND_PARCEL_CUSTODY = "RESIDENTIAL_PLOT_LAND_PARCEL_CUSTODY",

  COMMERCIAL_PLOT_LAND_PARCEL_VALUATION = "COMMERCIAL_PLOT_LAND_PARCEL_VALUATION",
  COMMERCIAL_PLOT_LAND_PARCEL_DIMENSIONS = "COMMERCIAL_PLOT_LAND_PARCEL_DIMENSIONS",
  COMMERCIAL_PLOT_LAND_PARCEL_EXISTENCE = "COMMERCIAL_PLOT_LAND_PARCEL_EXISTENCE",
  COMMERCIAL_PLOT_LAND_PARCEL_CUSTODY = "COMMERCIAL_PLOT_LAND_PARCEL_CUSTODY",

  // Real Estate Legal Verifications
  RESIDENTIAL_REAL_ESTATE_REGISTERED_SALE_DEED = "RESIDENTIAL_REAL_ESTATE_REGISTERED_SALE_DEED",
  RESIDENTIAL_REAL_ESTATE_PRIMARY_TITLE_DEED = "RESIDENTIAL_REAL_ESTATE_PRIMARY_TITLE_DEED",
  RESIDENTIAL_REAL_ESTATE_CHAIN_DEED = "RESIDENTIAL_REAL_ESTATE_CHAIN_DEED",
  RESIDENTIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED = "RESIDENTIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED",
  RESIDENTIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE = "RESIDENTIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE",
  RESIDENTIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT = "RESIDENTIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT",

  COMMERCIAL_REAL_ESTATE_REGISTERED_SALE_DEED = "COMMERCIAL_REAL_ESTATE_REGISTERED_SALE_DEED",
  COMMERCIAL_REAL_ESTATE_PRIMARY_TITLE_DEED = "COMMERCIAL_REAL_ESTATE_PRIMARY_TITLE_DEED",
  COMMERCIAL_REAL_ESTATE_CHAIN_DEED = "COMMERCIAL_REAL_ESTATE_CHAIN_DEED",
  COMMERCIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED = "COMMERCIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED",
  COMMERCIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE = "COMMERCIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE",
  COMMERCIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT = "COMMERCIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT",

  INDUSTRIAL_REAL_ESTATE_REGISTERED_SALE_DEED = "INDUSTRIAL_REAL_ESTATE_REGISTERED_SALE_DEED",
  INDUSTRIAL_REAL_ESTATE_PRIMARY_TITLE_DEED = "INDUSTRIAL_REAL_ESTATE_PRIMARY_TITLE_DEED",
  INDUSTRIAL_REAL_ESTATE_CHAIN_DEED = "INDUSTRIAL_REAL_ESTATE_CHAIN_DEED",
  INDUSTRIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED = "INDUSTRIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED",
  INDUSTRIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE = "INDUSTRIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE",
  INDUSTRIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT = "INDUSTRIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT",

  // Land Parcel Legal Verifications
  AGRICULTURAL_LAND_PARCEL_REGISTERED_SALE_DEED = "AGRICULTURAL_LAND_PARCEL_REGISTERED_SALE_DEED",
  AGRICULTURAL_LAND_PARCEL_PRIMARY_TITLE_DEED = "AGRICULTURAL_LAND_PARCEL_PRIMARY_TITLE_DEED",
  AGRICULTURAL_LAND_PARCEL_CHAIN_DEED = "AGRICULTURAL_LAND_PARCEL_CHAIN_DEED",
  AGRICULTURAL_LAND_PARCEL_HISTORICAL_MOTHER_DEED = "AGRICULTURAL_LAND_PARCEL_HISTORICAL_MOTHER_DEED",
  AGRICULTURAL_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE = "AGRICULTURAL_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE",
  AGRICULTURAL_LAND_PARCEL_CERSAI_SEARCH_REPORT = "AGRICULTURAL_LAND_PARCEL_CERSAI_SEARCH_REPORT",

  NON_AGRICULTURAL_LAND_PARCEL_REGISTERED_SALE_DEED = "NON_AGRICULTURAL_LAND_PARCEL_REGISTERED_SALE_DEED",
  NON_AGRICULTURAL_LAND_PARCEL_PRIMARY_TITLE_DEED = "NON_AGRICULTURAL_LAND_PARCEL_PRIMARY_TITLE_DEED",
  NON_AGRICULTURAL_LAND_PARCEL_CHAIN_DEED = "NON_AGRICULTURAL_LAND_PARCEL_CHAIN_DEED",
  NON_AGRICULTURAL_LAND_PARCEL_HISTORICAL_MOTHER_DEED = "NON_AGRICULTURAL_LAND_PARCEL_HISTORICAL_MOTHER_DEED",
  NON_AGRICULTURAL_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE = "NON_AGRICULTURAL_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE",
  NON_AGRICULTURAL_LAND_PARCEL_CERSAI_SEARCH_REPORT = "NON_AGRICULTURAL_LAND_PARCEL_CERSAI_SEARCH_REPORT",

  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_REGISTERED_SALE_DEED = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_REGISTERED_SALE_DEED",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_PRIMARY_TITLE_DEED = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_PRIMARY_TITLE_DEED",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CHAIN_DEED = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CHAIN_DEED",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_HISTORICAL_MOTHER_DEED = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_HISTORICAL_MOTHER_DEED",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CERSAI_SEARCH_REPORT = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CERSAI_SEARCH_REPORT",

  RESIDENTIAL_PLOT_LAND_PARCEL_REGISTERED_SALE_DEED = "RESIDENTIAL_PLOT_LAND_PARCEL_REGISTERED_SALE_DEED",
  RESIDENTIAL_PLOT_LAND_PARCEL_PRIMARY_TITLE_DEED = "RESIDENTIAL_PLOT_LAND_PARCEL_PRIMARY_TITLE_DEED",
  RESIDENTIAL_PLOT_LAND_PARCEL_CHAIN_DEED = "RESIDENTIAL_PLOT_LAND_PARCEL_CHAIN_DEED",
  RESIDENTIAL_PLOT_LAND_PARCEL_HISTORICAL_MOTHER_DEED = "RESIDENTIAL_PLOT_LAND_PARCEL_HISTORICAL_MOTHER_DEED",
  RESIDENTIAL_PLOT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE = "RESIDENTIAL_PLOT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE",
  RESIDENTIAL_PLOT_LAND_PARCEL_CERSAI_SEARCH_REPORT = "RESIDENTIAL_PLOT_LAND_PARCEL_CERSAI_SEARCH_REPORT",

  COMMERCIAL_PLOT_LAND_PARCEL_REGISTERED_SALE_DEED = "COMMERCIAL_PLOT_LAND_PARCEL_REGISTERED_SALE_DEED",
  COMMERCIAL_PLOT_LAND_PARCEL_PRIMARY_TITLE_DEED = "COMMERCIAL_PLOT_LAND_PARCEL_PRIMARY_TITLE_DEED",
  COMMERCIAL_PLOT_LAND_PARCEL_CHAIN_DEED = "COMMERCIAL_PLOT_LAND_PARCEL_CHAIN_DEED",
  COMMERCIAL_PLOT_LAND_PARCEL_HISTORICAL_MOTHER_DEED = "COMMERCIAL_PLOT_LAND_PARCEL_HISTORICAL_MOTHER_DEED",
  COMMERCIAL_PLOT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE = "COMMERCIAL_PLOT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE",
  COMMERCIAL_PLOT_LAND_PARCEL_CERSAI_SEARCH_REPORT = "COMMERCIAL_PLOT_LAND_PARCEL_CERSAI_SEARCH_REPORT",

  PAN_IDENTITY_VERIFICATION = "PAN_IDENTITY_VERIFICATION",
  AADHAAR_IDENTITY_VERIFICATION = "AADHAAR_IDENTITY_VERIFICATION",
  UDYAM_CERTIFICATE_IDENTITY_VERIFICATION = "UDYAM_CERTIFICATE_IDENTITY_VERIFICATION",
  DRIVING_LICENSE_IDENTITY_VERIFICATION = "DRIVING_LICENSE_IDENTITY_VERIFICATION",
  PASSPORT_IDENTITY_VERIFICATION = "PASSPORT_IDENTITY_VERIFICATION",
  VOTER_ID_IDENTITY_VERIFICATION = "VOTER_ID_IDENTITY_VERIFICATION",
  CIN_IDENTITY_VERIFICATION = "CIN_IDENTITY_VERIFICATION",

  CREDIT_REPORT_PROFILE_VERIFICATION = "CREDIT_REPORT_PROFILE_VERIFICATION",
  BANK_STATEMENT_PROFILE_VERIFICATION = "BANK_STATEMENT_PROFILE_VERIFICATION",
  BANK_ACCOUNT_PROOF_PROFILE_VERIFICATION = "BANK_ACCOUNT_PROOF_PROFILE_VERIFICATION",
  EMPLOYMENT_PROOF_PROFILE_VERIFICATION = "EMPLOYMENT_PROOF_PROFILE_VERIFICATION",
  INCOME_PROOF_PROFILE_VERIFICATION = "INCOME_PROOF_PROFILE_VERIFICATION",
  RESIDENCE_ADDRESS_PROOF_PROFILE_VERIFICATION = "RESIDENCE_ADDRESS_PROOF_PROFILE_VERIFICATION",
  BUSINESS_ADDRESS_PROOF_PROFILE_VERIFICATION = "BUSINESS_ADDRESS_PROOF_PROFILE_VERIFICATION",
  RATION_CARD_PROFILE_VERIFICATION = "RATION_CARD_PROFILE_VERIFICATION",
  UAN_PROFILE_VERIFICATION = "UAN_PROFILE_VERIFICATION",
  EPFO_PROFILE_VERIFICATION = "EPFO_PROFILE_VERIFICATION",
  ITR_PROFILE_VERIFICATION = "ITR_PROFILE_VERIFICATION",
  FSSAI_PROFILE_VERIFICATION = "FSSAI_PROFILE_VERIFICATION",
  BUILDING_SANCTION_PLAN_PROFILE_VERIFICATION = "BUILDING_SANCTION_PLAN_PROFILE_VERIFICATION",
  TRADE_LICENSE_PROFILE_VERIFICATION = "TRADE_LICENSE_PROFILE_VERIFICATION",
  GST_CERTIFICATE_PROFILE_VERIFICATION = "GST_CERTIFICATE_PROFILE_VERIFICATION",
  ELECTRICITY_BILL_PROFILE_VERIFICATION = "ELECTRICITY_BILL_PROFILE_VERIFICATION",
  FORM_26AS_PROFILE_VERIFICATION = "FORM_26AS_PROFILE_VERIFICATION",
  RENT_AGREEMENT_PROFILE_VERIFICATION = "RENT_AGREEMENT_PROFILE_VERIFICATION",
  CA_CERTIFICATE_PROFILE_VERIFICATION = "CA_CERTIFICATE_PROFILE_VERIFICATION",
  SHOP_ACT_CERTIFICATE_PROFILE_VERIFICATION = "SHOP_ACT_CERTIFICATE_PROFILE_VERIFICATION",
  MCA_PROFILE_VERIFICATION = "MCA_PROFILE_VERIFICATION",
  OTHERS = "OTHERS",
}

export enum FormFieldType {
  SELECT = "SELECT",
  TEXT = "TEXT",
  TEXT_AREA = "TEXT_AREA",
  MULTISELECT = "MULTISELECT",
  FLOAT = "FLOAT",
  INT = "INT",
  DATE = "DATE",
  RADIOBUTTON = "RADIOBUTTON",
  CHECKBOX = "CHECKBOX",
}

export interface FieldOption {
  label: string;
  value: string | boolean;
}

export interface FieldConfig {
  label: string;
  key: string;
  field_type: FormFieldType;
  options?: FieldOption[];
  is_mandatory?: boolean;
}

export interface FormConfig {
  fields: FieldConfig[];
  leader_field_keys: string[];
}

export interface FormConfigData {
  form_type: FormType;
  configs: FormConfig;
}

export interface GetFormConfigsResponse {
  form_configs: FormConfigData[];
}

export interface GetFormConfigsParams {
  form_type?: FormType[];
}

const FormConfigsAPI = {
  getFormConfigs: async (params?: GetFormConfigsParams) => {
    const response: AxiosResponse<GetFormConfigsResponse> =
      await axiosInstance.get("/v1/form-configs", {
        params: {
          form_type: params?.form_type,
        },
      });

    return response.data;
  },
};

export default FormConfigsAPI;